import { cashApi } from '../../template/SideNav/sideNavSlice';

interface ContactGroupProps {
  count: number;
  next?: null;
  previous?: null;
  results: ContactProps[];
}

interface ContactProps {
  [x: string]: any;
  id: number;
  name: string;
  email: string;
  location: string;
}

const contactGroupApi = cashApi
  .enhanceEndpoints({ addTagTypes: ['ContactGroup', 'Contact'] })
  .injectEndpoints({
    endpoints: (builder) => ({
      getContactGroup: builder.query<ContactGroupProps, void>({
        query: () => {
          return `v1/web-contents/contact/groups/`;
        },
        providesTags: ['ContactGroup'],
      }),

      getContact: builder.query<ContactProps, void>({
        query: () => {
          return `v1/web-contents/contact/contacts/?limit=100000`;
        },
        providesTags: ['Contact'],
      }),
    }),
  });

export const { useGetContactGroupQuery, useGetContactQuery } = contactGroupApi;
